import { render, staticRenderFns } from "./statistics-modal___1.vue?vue&type=template&id=1dcd1c16&scoped=true"
import script from "./statistics-modal___1.vue?vue&type=script&lang=js"
export * from "./statistics-modal___1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcd1c16",
  null
  
)

export default component.exports